import React, { createContext, useContext, useState, ReactNode } from "react";

interface SourceInfoModalData {
  productName?: string;
  dataSource?: string;
}

interface ModalContextType {
  isSourceInfoModalOpen: boolean;
  sourceInfoModalData: SourceInfoModalData;
  openSourceInfoModal: (data: SourceInfoModalData) => void;
  closeSourceInfoModal: () => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

interface ModalProviderProps {
  children: ReactNode;
}

export const ModalProvider = ({ children }: ModalProviderProps) => {
  const [isSourceInfoModalOpen, setIsSourceInfoModalOpen] = useState(false);
  const [sourceInfoModalData, setSourceInfoModalData] =
    useState<SourceInfoModalData>({});

  const openSourceInfoModal = (data: SourceInfoModalData) => {
    setSourceInfoModalData(data);
    setIsSourceInfoModalOpen(true);
  };

  const closeSourceInfoModal = () => {
    setIsSourceInfoModalOpen(false);
    setSourceInfoModalData({});
  };

  return (
    <ModalContext.Provider
      value={{
        isSourceInfoModalOpen,
        sourceInfoModalData,
        openSourceInfoModal,
        closeSourceInfoModal,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => {
  const context = useContext(ModalContext);
  if (context === undefined) {
    throw new Error("useModal must be used within a ModalProvider");
  }
  return context;
};
